import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const STATUS_ACCENT = {
  neutral: "text-slate-500",
  success: "text-emerald-500",
  warning: "text-amber-500",
  danger: "text-rose-500",
  info: "text-blue-500",
};

export const KpiCard = ({ testId, label, value, icon: Icon, status = "neutral", to }) => {
  const content = (
    <>
      <div className="flex items-center justify-between">
        <p className="text-xs font-mono uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400">{label}</p>
        {Icon && <Icon className={cn("w-4 h-4", STATUS_ACCENT[status])} />}
      </div>
      <p className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-50">{value}</p>
    </>
  );
  const className = "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-5 flex flex-col gap-2 transition-colors hover:border-emerald-400 hover:shadow-sm cursor-pointer";
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={className}>
        {content}
      </Link>
    );
  }
  return (
    <div data-testid={testId} className={className}>
      {content}
    </div>
  );
};
